import { FC, useState } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { FormControl, InputLabel, Select, MenuItem, Grid, Button, Divider } from '@mui/material';
import { FilterList, ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { IDropdownResponse } from '../../models/util';

interface IListingInteractionTypesFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  activityTypes: IDropdownResponse[];
  selectedActivityType: null | number;
  setSelectedActivityType: (val: null | number) => void;
  hasAppliedFilters: boolean;
  setHasAppliedFilters: (val: boolean) => void;
}

export const ListingInteractionTypesFilters: FC<IListingInteractionTypesFilters> = ({
  isLoading,
  applyFilters,
  activityTypes,
  selectedActivityType,
  setSelectedActivityType,
  hasAppliedFilters,
  setHasAppliedFilters,
}) => {
  const [isMobileFilterButtonOpen, setIsMobileFilterButtonOpen] = useState<boolean>(false);
  const classes = useStyles({ isMobileFilterButtonOpen });

  return (
    <>
      <Grid container spacing={1} alignItems="center" className={classes.searchWrapper}></Grid>
      <Button
        color="secondary"
        variant="contained"
        className={classes.mobileButton}
        startIcon={<FilterList />}
        endIcon={isMobileFilterButtonOpen ? <ArrowDropUp /> : <ArrowDropDown />}
        onClick={() => {
          setIsMobileFilterButtonOpen(!isMobileFilterButtonOpen);
        }}
      >
        Filters
      </Button>
      {!isMobileFilterButtonOpen && <Divider className={classes.divider} />}
      <Grid container spacing={1} alignItems="center" className={classes.wrapper}>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl
            classes={{ root: classes.formControlRoot }}
            fullWidth
            variant="outlined"
            size="small"
          >
            <InputLabel htmlFor="typeLabel" className={classes.ellipsis}>
              Activity Type
            </InputLabel>
            <Select
              disabled={isLoading}
              name="activity-type"
              labelId="typeLabel"
              id="activity-type"
              value={selectedActivityType}
              onChange={({ target: { value } }) => setSelectedActivityType(Number(value))}
            >
              {activityTypes?.map((type) => {
                  return (
                    <MenuItem key={type.value} value={type.value}>
                      {type.description}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};

const useStyles = makeStyles<Theme, { isMobileFilterButtonOpen?: boolean }>((theme: Theme) => ({
  mobileButton: {
    width: '100%',
    '@media only screen and (min-width: 900px)': {
      display: 'none',
    },
  },
  button: {
    marginTop: 4,
    marginBottom: 4,
    height: 40,
    textTransform: 'capitalize',
    width: '100%',

    '@media only screen and (min-width: 900px)': {
      width: 'auto',
    },
  },
  resetButton: {
    '@media only screen and (min-width: 900px)': {
      marginLeft: '1rem',
    },
  },
  wrapper: ({ isMobileFilterButtonOpen }) =>
    isMobileFilterButtonOpen
      ? {
          marginTop: 10,
          marginBottom: 10,
          display: 'flex',
        }
      : {
          display: 'none',
          marginBottom: '1rem',
          '@media only screen and (min-width: 900px)': {
            display: 'flex',
          },
        },
  divider: {
    display: 'block',
    marginBottom: '1rem',
    '@media only screen and (min-width: 900px)': {
      display: 'none',
    },
  },
  gridItem: {
    padding: `3px 8px !important`,
    '@media only screen and (min-width: 900px)': {
      padding: `8px !important`,
    },
  },
  searchIcon: {
    cursor: 'pointer',
    color: '#9e9e9e',
  },
  ellipsis: {
    backgroundColor: 'white',
    fontSize: 14,
    width: 'auto',
    whiteSpace: 'normal',
    overflow: 'visible',
    '@media (min-width: 960px)': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    '@media (min-width: 1400px)': {
      width: 'auto',
      whiteSpace: 'normal',
      overflow: 'visible',
    },
  },
  formControlRoot: {
    marginTop: 0,
  },
  textFieldRoot: {
    marginBottom: 0,
  },
  searchWrapper: {
    marginBottom: '1rem',
    '@media only screen and (min-width: 900px)': {
      display: 'flex',
      marginBottom: '1rem',
    },
  },
  clearSearchButton: {
    '@media (min-width: 408px)': {
      marginTop: 3,
      marginLeft: '1rem',
    },
  },
  searchButton: {
    minWidth: '8rem',
  },
  searchRoot: {
    marginTop: 0,
  },
}));
